<template>
  <div class="content">
    <div class="cont">
      <div class="top">
        <div class="title">佣金概览</div>
        <div class="box" id="">
          <div class="list" v-for="(item, index) in res.money" :key= index>
            <div class="inner">
              <div class="name">{{item.title}}</div>
              <div class="num">{{item.number}}</div>
            </div>
          </div>
        </div>
        <div class="title">分销商概览</div>
        <div class="box">
          <div class="list" v-for="(item, index) in res.distributor" :key= index>
            <div class="inner">
              <div class="name">{{item.title}}</div>
              <div class="num">{{item.number}}</div>
            </div>
          </div> 
          <div class="list" id="echarts-pie"></div>
        </div>
      </div>
    <div class="bottom">
      <div class="list" id="echarts-line">
      </div>
      <div class="list" id="echarts-column">
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import echarts from "echarts";
import { mapGetters } from "vuex";
import { getSpreadCount } from "@/api/user"
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      res: {
        money: [
          {
            title: "提现待审核(元)",
            number: 0,
          },
          {
            title: "提现待打款(元)",
            number: 0,
          },
          {
            title: "累计佣金",
            number: 0,
          },
          {
            title: "提现佣金",
            number: 0,
          },
        ],
        distributor: [
          {
            title: "待审核(人)",
            number: 0,
          },
          {
            title: "分销商(人)",
            number: 0,
          },
          {
            title: "推广人数",
            number: 0,
          }
        ]
      }
        
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData(){
      getSpreadCount({app_id: this.app_id}).then(res => {
        if(res.code == 200){
          this.res.money[0].number = res.data.waitAudit;
          this.res.money[1].number = res.data.waitPayment;
          this.res.money[2].number = res.data.totalCommission;
          this.res.money[3].number = res.data.totalWithdraw;
          this.res.distributor[0].number = res.data.waitUsers
          this.res.distributor[1].number = res.data.spreadUsers
          this.res.distributor[2].number = res.data.users
          var e1 = {
            names: res.data.positionCommission.map( x => x.mobile),
            values: res.data.positionCommission.map( x => x.total_commission)
          }
          var e2 = {
            names: res.data.positionSpread.map( x => x.mobile),
            values: res.data.positionSpread.map( x => x.spread_num)
          }
          var e3 = {
            names: res.data.level.map( x => x.level_name),
            num: res.data.level.map( x => x.spreader)
          }
          var e3value = [];
          e3.num.forEach( (item,index) => {
            var pushItem = {
              value: item,
              name: e3.names[index]
            }
            e3value.push(pushItem)
          })
          e3.values = e3value;
          var edata = [e1,e2,e3];
          this.drawEcharts(edata);
        }
      })
    },
    drawEcharts(data){
      var option = {
        tooltip: {
          trigger: 'axis',
        },
        title: {
          text: '分销佣金排行'
        },
        xAxis: {
          type: 'category',
          data: data[0].names,
          axisLabel: {
            interval: 0,
            rotate: -45
          },
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: data[0].values,
          type: 'bar',
        }]
      }
      var option2 = {
        tooltip: {
          trigger: 'axis',
        },
        title: {
          text: '分销人数排行'
        },
        xAxis: {
          type: 'category',
          data: data[0].names,
          axisLabel: {
            interval: 0,
            rotate: -45
          },
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: data[1].values,
          type: 'bar',
        }]
      }
      var option3 = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 1,
          top: 20,
          data: data[2].names
        },
        series: [
          {
            name: '分销等级',
            type: 'pie',
            radius: ['60%', '75%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
            },
            left: '40%',
            minAngle: 1,
            emphasis: {
              label: {
                show: true,
                fontSize: '14',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: data[2].values
          }
        ]
      }
      let echart1 = echarts.init(document.getElementById("echarts-line"));
      echart1.setOption(option);
      let echart2 = echarts.init(document.getElementById("echarts-column"));
      echart2.setOption(option2);
      let echart3 = echarts.init(document.getElementById("echarts-pie"));
      echart3.setOption(option3);
    }
  }
};

  
</script>

<style lang="scss" scoped>
.content{
  padding: 0px 40px;
  height: 100%;
  background: rgba(248,250,255,1);
  overflow: auto;
  .cont{
    height: 100%;
    .top {
      .title {
        height: 56px;
        line-height: 56px;
        font-size: 16px;
        font-weight: 510;
      }
      .box{
        display: flex;
        justify-content: space-around;      
        .list {
          width: 24%;
          height: 180px;
          border-radius: 10px;
          border: 1px solid #EBEEF5;
          background: #eae7d9;
          .inner {
            height: 180px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .name {
              height: 25%;
              font-size: 18px;
              font-weight: 650;
              color: #1f4068;
            }
            .num{
              height: 25%;
              font-size: 30px;
              font-weight: 650;
              color: #00bcd4;
            }
          }
        }
        .current {
          box-shadow:3px 3px 6px 0px rgba(0,0,0,0.07);
        }
      }
    }
    .bottom {
      height: calc(100% - 472px);
      padding: 0 10px;
      display: flex;
      margin-top: 18px;
      justify-content: space-between;
      .list {
        width: 49%;
        height: 400px;
        padding: 10px;
        border-radius: 10px;
        background: #fff;
      }
    }
  }
}
</style>
